
export const Loading = () => {
    return (
      <div className="">
          <div className="text-center">
          <h3>Espere por favor</h3>
          <span> Cargando datos...</span>
          </div>
      </div>
    )
  }
  